import moment, { type Moment } from "moment";

const validTimeFormats = [
  //    "H:m",      // 0:0
  "H:mm", // 0:00
  //    "HH:m",     // 00:0
  "HH:mm", // 00:00
  "HHmm", // 0000
  //    "h:m a",    // 12:0 am
  "h:mm a", // 12:00 am
  "h:mma",
  "h a", // 12 am
  "ha", // 12am
  "H" // 0
];
const validDateFormats = validTimeFormats.map((timeFormat) => `${timeFormat}`);

const findDelimiter = (input: string): string | undefined => {
  const firstNonNumericChars = /[^0-9]{1,}/;
  const amPm = /am|pm/i;
  const withoutAmPm = input.replace(amPm, "").trim();
  const delimiters = withoutAmPm.match(firstNonNumericChars);
  return delimiters == null ? undefined : delimiters.join("");
};

export const parseTime = (input: string): Moment => {
  if (input == null) {
    return moment(null);
  }

  const trimmedInput = input.trim();
  const delimiter = findDelimiter(trimmedInput);
  const inputWithProperDelimiter = (delimiter == null) ? trimmedInput : trimmedInput.replace(delimiter, ":");

  const inputWithDate = `${inputWithProperDelimiter}`;
  const parsedMoment: Moment = moment.utc(inputWithDate, validDateFormats, true);
  return parsedMoment;
};